"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferDeathEffectHandler = exports.DeferDeathEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const EventFilter_1 = require("../../events/EventFilter");
class DeferDeathEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.DeferDeath;
        this.__typeName = "DeferDeath";
        this.name = "Defer Death";
        this.harmful = false;
    }
}
exports.DeferDeathEffectArgs = DeferDeathEffectArgs;
let DeferDeathEffectHandler = class DeferDeathEffectHandler {
    apply(sequence, container, state) {
        state.meta.avoidDeathId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.AvoidDeathEffectArgs(),
            duration: Duration_1.Duration.Permanent,
        });
        state.meta.eventHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.DeathAvoided, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_DeferDeath_OnDeathAvoided", { creatorId: state.creatorId, parentEffectId: state.id }), EventFilter_1.EventFilter.mk("DeathAvoided", {
            consumedAvoidanceEffect: {
                eq: state.meta.avoidDeathId
            }
        }));
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.avoidDeathId);
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
DeferDeathEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DeferDeath)
], DeferDeathEffectHandler);
exports.DeferDeathEffectHandler = DeferDeathEffectHandler;
